import Button from "react-bootstrap/Button";

const ButtonModal = ({ action, training, resetForm }) => {
  const getClassName = () => {
    if (training === "training") {
      return " float-start m-1 visible";
    }
    if (action === "Edit") {
      return " float-start m-1 invisible";
    }
    return "float-start m-1 visible";
  };

  return (
    <div className="divindex">
      <div className={getClassName()}>
        &nbsp;&nbsp;&nbsp;
        {
          action === "Upload" ?
            null
            :
            <Button className="resetbtn" onClick={resetForm}>
              Reset
            </Button>
        }
      </div>
      <div className="float-end m-1">
        <Button type="submit" className="submitbtn">
          {action === "Edit" ? "Update" : "Add"}
        </Button>
        &nbsp;&nbsp;&nbsp;
      </div>
    </div>
  );
};

export default ButtonModal;